import { kebabCase } from "lodash";

const customer_zh_cn = {
  toolbar: {
    add: '新增',
    edit: '编辑'
  },
  form: {
    id: '编码',
    no: '编号',
    code: '编码',
    financial_code: '财务编码',
    form: '表单',
    name: '名称',
    title: '标题',
    tags: '标签、关键词',
    unit: '单位',
    wrapUnit: '包装单位',
    clearingUnit: '结算单位',
    specification: '产品规格',
    clearingUnit: '结算单位',
    enterpriseId: '供应商',
    source: '来源',
    sort: '排序',
    parent_name: '父节点名称',
    alias: '别名简称',
    type: '类型',
    content: '内容',
    classify: '分类',
    address: '地址',
    bewrite: '备注',
    target: '目标受众',
    description: '描述',
    author: '作者来源',
    article_time: '文章日期',
    desc: '描述',
    login_name: '登录账号',
    telephone: '电话',
    mobilephone: '手机',
    gender: '性别',
    work_unit: '工作单位',
    birthday: '出生日期',
    weixin: '微信',
    email: '电子邮箱',
    quarters: '岗位',
    positional_titles: '职称',
    highest_education: '最高学历',
    dept: '部门',
    pinyin: '拼音、编码',
    simple_name: '简称',
    org_code: '社会统一代码',
    website: '网址',
    fax: '传真',
    registered_capital: '注册资本',
    registered_date: '注册日期',
    location: '行政区划',
    post_code: '邮政编码',
    idea: '理念',
    summary: '摘要',
    isCompany: '是否单位',
    political: '政治面貌',
    achievement: '成果',
    intellectual: '专利',
    honor: '荣誉',
    invent: '发明',
    inventor: '发明人',
    leading_official: '负责人',
    proprietor: '专利权人',
    apply_date: '申请日期',
    belong_date: '所属日期',
    done_unit: '完成单位',
    award_unit: '发奖单位',
    winning_unit: '获奖单位',
    honor_date: '获奖日期',
    grade: '等级',
    integral: '积分',
    integral_date: '积分日期',
    user: '人员',
    quantity: '数量',
    apply: '申报',
    apply_info: '申报信息',
    resume: '简述',
    details: '详情',
    remarks: '备注',
    handling_user: '处理人员',
    handling_suggestion: '处理意见',
    act_key: '流程KEY',
    act_description: '流程描述', 
    act_category: '流程分类',
  },
  message: {
    success: '操作成功',
    error: '操作失败'
  }
}
export default customer_zh_cn;